<div class="h-100 py-0 fx-column" [class.compact]="compact" [class.fx-gap-0]="!compact">

  <!-- Title -->
  <div class="fx-row y-center x-space-between">
    <!-- If we passed in a template for the header, use that. Otherwise, use default-->
    @if (!titleTemplate) {
      @if (title || header || subheader) {
        <div class="fx-column" [class.pb-3]="!compact">
          <span class="m-0 mat-h2 dialog-title line-height-0" [class.font-weight-bold]="!compact">{{ header || title}}</span>
          @if (subheader) {
            <span class="mat-body-1 dialog-subtitle mat-hint m-0 line-height-0 card-subheader">{{subheader}}</span>
          }
        </div>
      }
    } @else {
      <ng-template [ngTemplateOutlet]="titleTemplate" />
    }

    @if (!removeClose) {
      <button class="m-0 close-button fx-0-0-auto" mat-icon-button (click)="onCloseClicked()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <!-- Content -->
  @if (!contentTemplate) {
    <div class="banner-text prompt-text px-0" mat-dialog-content [class.py-sm]="!compact" [innerHTML]="message">
    </div>
  } @else {
    <ng-template [ngTemplateOutlet]="contentTemplate" />
  }

  <!-- Actions -->
  @if (primaryAction || otherActions?.length || actionsTemplate) {
    @if (!actionsTemplate) {
      <div mat-dialog-actions >
        <div class="w-100 fx-row-wrap x-end y-center fx-gap-sm">
          @for (action of otherActions; track action) {
            <a class="cancel-btn m-0" mat-button [id]="toButtonId(action.text)" (click)="onActionClicked(action)">{{action.text}}</a>
          }
          @if (primaryAction) {
            <button class="m-0" color="primary" mat-raised-button type="button" [id]="toButtonId(primaryAction.text)" (click)="onActionClicked(primaryAction)">{{primaryAction.text}}</button>
          }
        </div>
      </div>
    } @else {
      <ng-template [ngTemplateOutlet]="actionsTemplate" />
    }
  }
</div>
